export default __webpack_public_path__ + "roboto-regular-webfont.woff";